import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const TradeInAppraiserAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "trade-in-appraiser" */ './trade-in-appraiser'),
  componentName: 'TradeInAppraiser',
});
